import React from 'react';
import styled from 'styled-components';
import { Accordion, Typography } from '@/components/atoms';
import { IAccordionFilter } from './AccordionFilterCmp';

interface IStyleProps {
  $indent?: boolean;
  $active?: boolean;
}

const CustomMuiAccordion = styled(Accordion)<IStyleProps>`
  margin: 0px 0px;
  background-color: ${props =>
    props.$active && !props.$indent
      ? props.theme.filterPanel.backgroundColor
      : 'inherit'};
  &.MuiAccordion-rounded {
    border-radius: 0;
  }

  &.Mui-expanded {
    margin: 0px;
    border-color: ${props => props.theme.paletteDefault.grey1};
  }

  .MuiAccordionSummary-expandIcon {
    color: ${props => props.theme.paletteDefault.grey1};
    transform: rotate(-90deg);
    margin: 0;
    padding: 0;
  }
  .MuiAccordionSummary-expandIcon.Mui-expanded {
    transform: rotate(0deg);
    padding: 0;
  }
  .MuiAccordionSummary-content {
    margin: 0;
  }
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }

  .MuiAccordionSummary-root,
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 40px;
    max-height: 40px;
    padding: 0 0;
  }

  .MuiAccordionDetails-root {
    padding: 0;
    width: 100%;
  }
  .MuiIconButton-root {
    padding: 4px;
  }
  &::before {
    opacity: 0;
  }
`;

const NumSelectedItemsWrapper = styled.div`
  width: 16px;
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.filterPanel.numSelectedItemsBg};
`;
const NumSelectedItems = styled(Typography)`
  color: ${props => props.theme.filterPanel.numSelectedItemsColor};
`;

const Summary = styled.div`
  padding: 4px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const SummaryTypography = styled(Typography)`
  font-size: 16px;
`;

const ContentWrapper = styled.div<IStyleProps>`
  display: flex;
  flex-direction: column;
  margin: ${props => (props.$indent ? '4px' : 0)} 0 4px
    ${props => (props.$indent ? '14px' : 0)};
  width: calc(100% - ${props => (props.$indent ? 16 : 0)}px);
`;

const AccordionFilter: React.FC<IAccordionFilter> = ({
  heading,
  indent,
  active,
  showNumber,
  ...props
}) => {
  const { expanded, defaultExpanded } = props;
  const summary = (
    <Summary>
      <SummaryTypography datatype="body_1">{heading}</SummaryTypography>

      {active && !expanded && !defaultExpanded && showNumber && (
        <NumSelectedItemsWrapper>
          <NumSelectedItems datatype="body_1">
            <span>1</span>
          </NumSelectedItems>
        </NumSelectedItemsWrapper>
      )}
    </Summary>
  );
  return (
    <CustomMuiAccordion
      {...props}
      $indent={indent}
      $active={active}
      summary={summary}
      TransitionProps={{
        timeout: {
          appear: 500,
          enter: 400,
          exit: 300,
        },
      }}>
      <ContentWrapper $indent={indent}>{props.children}</ContentWrapper>
    </CustomMuiAccordion>
  );
};

AccordionFilter.defaultProps = {
  showNumber: true,
};
export default AccordionFilter;
